module.exports = __webpack_public_path__ + "media/images/phone-3020a18ba8935d6cd63def151b3d5597.png";